// eslint-disable-next-line max-classes-per-file
import { EventEmitter, OnDestroy } from "@angular/core";
import { BaseDestroyableMixin, IDestroyable } from "core-library/mixins/base-destroyable.mixin";
import { Constructor } from "core-library/types/constructor";
import { Subject, Subscription } from "rxjs";

export const DestroyableMixin = <TBaseClass extends Constructor<object>>(
    BaseClass: TBaseClass
): TBaseClass & Constructor<IDestroyable> => {
    return class DestroyableExtension extends BaseDestroyableMixin(BaseClass) implements OnDestroy {
        public ngOnDestroy(): void {
            this.destroy();
        }

        protected destroyMember(value: object): void {
            if (value instanceof Subscription && !value.closed) {
                value.unsubscribe();
                return;
            }

            if (value instanceof EventEmitter) {
                return;
            }

            if (value instanceof Subject) {
                value.complete();
                return;
            }
        }
    };
};

export class EmptyClassInstance {
}
